/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Wrapper } from "./styled";
import ButtonTextOnly from "../../../../../../commons/Buttons/ButtonTextOnly";
import colors from "../../../../../../../styles/colorPalette";
import {
  captcha,
  internalId,
  payment,
  totalAmount,
  selectedArticles,
} from "../../../../../../../store/Concept/selectors";
import { getPaymentDetail, downLoadPdf } from "../../../../../../../store/Concept/actions";
import { getPaymentFormat } from "../../../../functions";
import { getParam } from "../../../../../../../utils/functions";

const PrintButton = () => {
  const dispatch = useDispatch();
  const interId = useSelector(internalId);
  const intId = useSelector(internalId);
  const total = useSelector(totalAmount);
  const paymentReq = useSelector(payment);
  const [param, setParam] = useState(null);
  const captchaValue = useSelector(captcha);
  const items = useSelector(selectedArticles);
  const tot = parseInt(total);
  const disabled = items.length === 0 || tot === 0;

  const print = () => {
    if (!paymentReq && !param) {
      dispatch(getPaymentDetail(interId, getPaymentFormat(total, intId, interId)));
      return null;
    }
    if (!param) {
      dispatch(downLoadPdf(interId));
    } else {
      dispatch(downLoadPdf(param));
    }
  };

  const getIsDisabled = () => {
    if (disabled) {
      return true;
    }
    if (!param) {
      return !captchaValue;
    }
    return false;
  };

  useEffect(() => {
    setParam(getParam("id"));
  }, []);

  return (
    <Wrapper>
      <ButtonTextOnly
        onClick={print}
        fontSize={"14px"}
        background={colors.gray1}
        color={colors.blue1}
        text={"Imprimir"}
        disabled={getIsDisabled()}
      />
    </Wrapper>
  );
};

export default PrintButton;
